import { createContext, useContext, useState } from "react";
import { handleData } from "../api";
import { sortActiviteitenByDate, stringToDate, formatDateShort, fullName } from "../helperfunctions/helperfunctions";

const AdminActiviteitenContext = createContext(null);

export const AdminActiviteitenProvider = ({children}) => {

    const [adminActiviteiten, setAdminActiviteiten] = useState(null);
    const [adminFutureActiviteiten, setAdminFutureActiviteiten] = useState([]);
    const [adminPastActiviteiten, setAdminPastActiviteiten] = useState([]);
    const [adminOpenTaken, setAdminOpenTaken] = useState([]);
    const [adminVoltooideTaken, setAdminVoltooideTaken] = useState([]);
    const [adminNietBevestigdeTaken, setAdminNietBevestigdeTaken] = useState([]);
    const [adminBevestigdeTaken, setAdminBevestigdeTaken] = useState([]);
    const [loadingMessage, setLoadingMessage] = useState('');
    const [adminTakenVrijwilligers, setadminTakenVrijwilligers] = useState([]);

    const loadAdminActiviteiten = async() => {
        const data = {
            method: 'GET',
            path: 'activiteiten/admin'
        }
        setLoadingMessage('Data wordt geladen');
        const result = await handleData(data);
        if (result.data.data) {
            const sortedActiviteiten = result.data.data;
            sortActiviteitenByDate(sortedActiviteiten);
            setAdminActiviteiten(sortedActiviteiten);

            const today = new Date();
            const futureActiviteiten = sortedActiviteiten.filter(item=> {
                const itemDate = stringToDate(item.datum);
                return today <= itemDate;
            });
            const pastActiviteiten = sortedActiviteiten.filter(item=> {
                const itemDate = stringToDate(item.datum);
                return today >= itemDate;
            });
            setAdminFutureActiviteiten(futureActiviteiten);
            setAdminPastActiviteiten(pastActiviteiten);

            const takenVrijwilligersArray = [];
            sortedActiviteiten.forEach(element => {
                const activiteitID = element._id;
                const activiteitNaam = element.naam;
                const activiteitDatum = formatDateShort(element.datum);
                element.taken.forEach(taak => {
                    if (taak.vrijwilliger) {
                        const vrijwilligersTaak = {
                            activiteitID: activiteitID,
                            activiteitNaam: activiteitNaam,
                            activiteitDatum: activiteitDatum,
                            taakID: taak._id,
                            taakNaam: taak.taaknaam,
                            // dagdeel: taak.dagdeel,
                            taakBevestigd: taak.bevestigd,
                            vrijwilliger: taak.vrijwilliger._id,
                            taakVoltooid: taak.vrijwilligervoltooid || ""
                        }
                        takenVrijwilligersArray.push(vrijwilligersTaak);
                    }
                })
            });
            setadminTakenVrijwilligers(takenVrijwilligersArray);

            const voltooideTakenArray = [];
            pastActiviteiten.forEach(element => {
                const activiteitID = element._id;
                const activiteitNaam = element.naam;
                const activiteitDatum = formatDateShort(element.datum);
                element.taken.forEach(taak => {
                    const naam = taak.vrijwilliger ? fullName(taak.vrijwilliger) : "";
                    // if (taak.vrijwilliger && taak.bevestigd) {                
                    //     const naam = fullName(taak.vrijwilliger);
                    // }
                    const voltooideTaak = {
                        activiteitID: activiteitID,
                        activiteitNaam: activiteitNaam,
                        activiteitDatum: activiteitDatum,
                        taakID: taak._id,
                        taakNaam: taak.taaknaam,
                        dagdeel: taak.dagdeel,
                        taakBevestigd: taak.bevestigd,
                        vrijwilliger: naam,
                        taakVoltooid: taak.vrijwilligervoltooid || ""
                    }
                    voltooideTakenArray.push(voltooideTaak);
                });
            });
            setAdminVoltooideTaken(voltooideTakenArray);

            const openTakenArray = [];
            futureActiviteiten.forEach(element => {
                const activiteitID = element._id;
                const activiteitNaam = element.naam;
                const activiteitDatum = formatDateShort(element.datum);
                element.taken.forEach(taak => {
                    if (!taak.vrijwilliger) {
                        const openTaak = {
                            activiteitID: activiteitID,
                            activiteitNaam: activiteitNaam,
                            activiteitDatum: activiteitDatum,
                            taakID: taak._id,
                            taakNaam: taak.taaknaam,
                            dagdeel: taak.dagdeel
                        }
                        openTakenArray.push(openTaak);
                    }
                })
            });
            setAdminOpenTaken(openTakenArray);

            const nietBevestigdeTakenArray = [];
            futureActiviteiten.forEach(element => {
                const activiteitID = element._id;
                const activiteitNaam = element.naam;
                const activiteitDatum = formatDateShort(element.datum);
                element.taken.forEach(taak => {
                    if (taak.vrijwilliger && !taak.bevestigd) {                
                        const naam = fullName(taak.vrijwilliger);
                        const nietBevestigdeTaak = {
                            activiteitID: activiteitID,
                            activiteitNaam: activiteitNaam,
                            activiteitDatum: activiteitDatum,
                            taakID: taak._id,
                            taakNaam: taak.taaknaam,
                            dagdeel: taak.dagdeel,
                            taakBevestigd: taak.bevestigd,
                            vrijwilliger: naam,
                            vrijwilligerEmail: taak.vrijwilliger.loginemail,
                            vrijwilligerOpmerking: taak.vrijwilligerOpmerking || ""
                        }
                        nietBevestigdeTakenArray.push(nietBevestigdeTaak);
                    }
                })
            });
            setAdminNietBevestigdeTaken(nietBevestigdeTakenArray);

            const bevestigdeTakenArray = [];
            futureActiviteiten.forEach(element => {
                const activiteitID = element._id;
                const activiteitNaam = element.naam;
                const activiteitDatum = formatDateShort(element.datum);
                element.taken.forEach(taak => {
                    if (taak.vrijwilliger && taak.bevestigd) {                
                        const naam = fullName(taak.vrijwilliger);
                        const bevestigdeTaak = {
                            activiteitID: activiteitID,
                            activiteitNaam: activiteitNaam,
                            activiteitDatum: activiteitDatum,
                            taakID: taak._id,
                            taakNaam: taak.taaknaam,
                            dagdeel: taak.dagdeel,
                            taakBevestigd: taak.bevestigd,
                            vrijwilliger: naam,
                            vrijwilligerOpmerking: taak.vrijwilligerOpmerking || "",
                            vrijwilligerEmail: taak.vrijwilliger.loginemail,
                            aanvangstijd: taak.aanvangstijd,
                            vrijwilligersInfo: taak.vrijwilligersInfo
                        }
                        bevestigdeTakenArray.push(bevestigdeTaak);
                    }
                })
            });
            setAdminBevestigdeTaken(bevestigdeTakenArray);

            setLoadingMessage('');
    
    



        } else {
            setLoadingMessage("Er is iets misgegaan bij het laden van de data. Probeer het later nog eens.");
        }
    }

    return (
        <AdminActiviteitenContext.Provider
            value={{
                adminActiviteiten,
                adminFutureActiviteiten,
                adminPastActiviteiten,
                adminOpenTaken,
                adminVoltooideTaken,
                adminNietBevestigdeTaken,
                adminBevestigdeTaken,
                adminTakenVrijwilligers,
                loadingMessage,
                loadAdminActiviteiten
            }}

        >
            {children}
        </AdminActiviteitenContext.Provider>

    );
}

export const useAdminActiviteiten = () => {
    return useContext(AdminActiviteitenContext);
}